import { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { IoSettingsOutline } from "react-icons/io5";

import Toaster from "../../components/common/Toaster";
import Modal from "../../components/common/Modal";

import CorHeader from "./components/CorHeader";
import CorSettings from "./components/CorSettings";
import CorLoader from "./components/CorLoader";
import CorEmptyState from "./components/CorEmptyState";
import CorTable from "./components/CorTable";

import complianceService from "../../services/complianceService";
import moment from "moment";

const CorInformation = () => {
  const { id } = useParams();

  const [cor, setCor] = useState({});
  const [deadlines, setDeadlines] = useState([]);

  const [showSettings, setShowSettings] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [year, setYear] = useState(moment().format("yyyy"));

  const fetchDeadlines = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        const result = await complianceService.getCORDeadlineItemsAsync(
          id,
          year
        );

        if (mounted) {
          setDeadlines(result);
          setIsLoading(false);
        }
      } catch (ex) {
        setIsLoading(false);
        Toaster.Error("Something went wrong.");
      }
    },
    [id, year]
  );

  const handleRefresh = () => setRefresh(!refresh);

  useEffect(() => {
    let mounted = true;

    const fetchCor = async () => {
      try {
        const result = await complianceService.getCORInfoAsync(id);
        if (result === null) window.location = "/404";
        if (mounted) setCor(result);
      } catch (ex) {
        Toaster.Error("Something went wrong.");
      }
    };

    fetchCor();

    return () => {
      mounted = false;
    };
  }, [id]);

  useEffect(() => {
    let mounted = true;

    fetchDeadlines(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchDeadlines, refresh]);

  return (
    <div className="px-6 space-y-6 lg:px-0">
      <CorHeader id={id} cor={cor} />
      <div className="card p-0">
        <div className="flex justify-between items-center px-4 py-5 sm:px-6">
          <h3 className="text-gray-500">{year} Tax Calendar</h3>
          <IoSettingsOutline
            className="text-blue-500 cursor-pointer"
            onClick={() => setShowSettings(true)}
          />
        </div>
        {isLoading && <CorLoader />}
        {!isLoading && deadlines.length === 0 && (
          <CorEmptyState id={id} onRefresh={handleRefresh} />
        )}
        {!isLoading && deadlines.length > 0 && (
          <CorTable deadlines={deadlines} setDeadlines={setDeadlines} />
        )}
      </div>
      <Modal
        title="Settings"
        isOpen={showSettings}
        onClose={() => setShowSettings(false)}
        borderTop
      >
        <CorSettings year={year} setYear={setYear} setShow={setShowSettings} />
      </Modal>
    </div>
  );
};

export default CorInformation;
